import actionsTypes from '../constants/ActionsTypes';

const INITIAL_STATE = {
  totensPositions: {},
  selectorIdHideBlocks: null
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionsTypes.SET_TOTEM_POSITION:
      return {
        ...state,
        totensPositions: {
          ...state.totensPositions,
          [action.totemKey]: action.position
        }
      };
    case actionsTypes.SET_STATE:
      if (action.state?.DragnDropReducer) return action.state.DragnDropReducer;
      return state;

    case actionsTypes.SET_SELECTOR_ID_HIDE_BLOCKS:
      return { ...state, selectorIdHideBlocks: action.selectorIdHideBlocks };

    default:
      return state;
  }
}
